import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import PriorBroadcasts from "./components/PriorBroadcasts/PriorBroadcasts";
import axios from "axios";
import CacheBuster from 'react-cache-buster';
import { CookieSetting } from "cookiesetting-component";
import appversion from '../package.json';
import jsonData from "./components/ai-branding.json";


const Footer = lazy(() => import("./components/FooterNew/index"));
const Embrace = lazy(() => import("./components/Embrace/Embrace"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const LogoSection = lazy(() => import("./components/Logo Section/Logo"));
const VideoSection = lazy(() => import("./components/VideoSection/ExploreSection"));

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [timerData, setTimerData] = useState();
  const [formData, setFormData] = useState();

  const isProduction = process.env.NODE_ENV === 'production';
  const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }

    if (window.innerWidth>=768) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  }, []);

  useEffect(() => {
    const fetchMorganWebinarJSON = async () => {
      await axios.get(process.env.REACT_APP_LIONJSON_CDN_URL)
        .then(response => {
          const webinarJsonData = response.data;
          setBannerData(webinarJsonData.banner);
          setHighlightsData(webinarJsonData.highlights);
          setTimerData(webinarJsonData.countdown);
          setFormData(webinarJsonData.signupform);
        }, error => {
          console.log(error);
        });

    };
    fetchMorganWebinarJSON();
  }, []);

  return (

    <CacheBuster
      currentVersion={appversion.version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
      <div className="bodyContainer">
        <Header links={links} fetchpriority="high" isMobile={isMobile} />
        {bannerData ?
          <>
            <Body bannerData={bannerData} timerData={timerData} formData={formData} isMobile={isMobile} fetchpriority="high" />
            <PriorBroadcasts fetchpriority="low" />
            <Suspense fallback={<div />}>
              <Embrace links={links} fetchpriority="low" />
            </Suspense>
            <Suspense fallback={<div />}>
              <LogoSection fetchpriority="low" />
            </Suspense>
            <Suspense fallback={<div />}>
              {highlightsData ?
                <Highlights links={links} highlightsData={highlightsData} />
                : ""}
            </Suspense>
            <Suspense fallback={<div />}>
              <VideoSection links={links} fetchpriority="low" />
            </Suspense>
            <Suspense fallback={<div />}>
              <Footer links={links} />
            </Suspense>
            <CookieSetting 
              privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
              configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
              analytics={process.env.REACT_APP_ANALYTICS_PATH}
            />
          </>
          : ""}
      </div>
    </CacheBuster>
  );
}

export default App;
